// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "jquery/dist/jquery.min";
import "popper.js/dist/popper.min";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import "lib-flexible";
import store from "./store";
//通过全局方法 Vue.use() 使用插件。它需要在你调用 new Vue() 启动应用之前完成：
import Auth from "./directives/auth";

Vue.use(Auth);
Vue.use(ElementUI);

Vue.config.productionTip = false;

const Axios = axios.create({
  //请求接口
  //baseURL: "https://47.92.24.106:8088",
  //baseURL: "http://localhost:8088",
  //超时设置
  timeout: 8000,
  //请求头设置
  headers: {
    accept: "application/json",
    "Content-Type": "application/json"
  }
});

//在发送请求之前做些什么("请求拦截器")
Axios.interceptors.request.use(
  config => {
    //假设接口需要对接token，可以用store保存token,在拦截器中设置到header中
    //store需要安装、引入
    if (store.state.token != null && store.state.token.length > 0) {
      config.headers.common["token"] = store.state.token;
    }

    console.log("main.js:" + store.state.token);

    return config;
  },
  error => {
    // 对请求错误做些什么
    console.log(error);
  }
);

//respone拦截器 ==> 对响应做处理
Axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      if (error.response.status == 401) {
        //localStorage.removeItem('token');
        store.dispatch("UserLogin", "");
        // 重新跳转到login页面
        router.push("/login");
        return "error";
      }
    }

    return "error";
    //return instance.request(originalRequest);//例如再重复请求一次
  }
);

//将axios挂载到Vue的原型上
Vue.prototype.$axios = Axios;
Vue.prototype.serverURL = "https://www.zuijiamaidian.com";
//Vue.prototype.serverURL = "http://localhost:8088";
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js